<script>
export const group = 'Full'
</script>

<script setup>
import PositiveWaveLoop1 from '../../../assets/animations/energetic_frequencies/loops/positive_wave_loop_1.json'
import AnimatedBackground from '../../AnimatedBackground.vue'
import { colors } from '../../../tailwindTheme.config'
import CharacterJumpFromTheRight from './text_animations/CharacterJumpFromTheRight.vue'
import ForbiddenWordBalloon from './shared/ForbiddenWordBalloon.vue'
import ForbiddenWordDj from './shared/ForbiddenWordDj.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const timelineCounterWord1 = ref(null)
const timelineCounterWord2 = ref(null)
const timelineCounterWord3 = ref(null)
const timelineForbiddenWordBalloon = ref(null)
const djTimelines = []

onMounted(() => {
  const timeline = gsapTimeline({ name: 'ForbiddenWord' }).add(timelineCounterWord1, '>').add(timelineCounterWord2, '<').add(timelineCounterWord3, '<').add(timelineForbiddenWordBalloon, '<.03')

  djTimelines.forEach((djTimeline) => {
    timeline.add(djTimeline, '<0.2')
  })
})

const scheme = { backgroundColor: colors.q.cr.red.primary, color: '#DA2E1F' }

const djs = computed(() => {
  return (
    Object.entries(props.item?.enrichment?.wall ?? {})
      // eslint-disable-next-line no-unused-vars
      .filter(([_, x]) => x.count > 0)
      .slice(0, 6)
  )
})
</script>

<template>
  <AnimatedBackground :lottie="PositiveWaveLoop1" :backgroundColor="scheme.backgroundColor" :color="scheme.color">
    <div class="grid grid-rows-2 px-24 py-14 h-full w-full">
      <div class="font-cervo text-center flex flex-col space-y-8 items-center justify-center">
        <div class="w-1/3">
          <ForbiddenWordBalloon
            ref="forbiddenWordBalloon"
            class="font-bold text-q-cr-red-primary text-[13rem]"
            :total="item?.enrichment.grandTotal ?? 0"
            @timeline="timelineForbiddenWordBalloon = $event"
          />
        </div>
        <div class="flex space-x-8">
          <CharacterJumpFromTheRight class="text-white font-light" textSizeClass="text-[6rem]" textOutlineSizeClass="text-[12rem]" text="keer" @timeline="timelineCounterWord1 = $event" />
          <CharacterJumpFromTheRight
            class="text-white"
            textSizeClass="text-[6rem]"
            textOutlineSizeClass="text-[10rem]"
            :text="item.properties.forbiddenWord"
            @timeline="timelineCounterWord2 = $event"
          />
          <CharacterJumpFromTheRight class="text-white font-light" textSizeClass="text-[6rem]" textOutlineSizeClass="text-[12rem]" text="gezegd" @timeline="timelineCounterWord3 = $event" />
        </div>
      </div>

      <div class="flex-1 flex items-center justify-center w-full h-full">
        <div class="grid grid-rows-3 grid-flow-col gap-16">
          <div v-for="[position, dj] in djs" :key="position" class="flex flex-col w-full h-100 font-cervo ml-auto">
            <ForbiddenWordDj
              containerClasses="text-[4em] h-24"
              imageContainerClasses="-mt-52 -ml-6"
              imageClasses="ml-12 scale-75"
              positionClasses="w-48"
              nameClasses="pl-28"
              :position="position"
              :dj="dj"
              @timeline="djTimelines[position] = $event"
            />
          </div>
        </div>
      </div>
    </div>
  </AnimatedBackground>
</template>
